import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaProcessoAberto } from './types';

export const INITIAL_STATE: ConsultaProcessoAberto = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaProcessoAberto {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_PROCESSO_ABERTO_REQUEST: {
				draft.status = 100;
				break;
			}

			case Types.CONSULTA_PROCESSO_ABERTO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_PROCESSO_ABERTO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_PROCESSO_ABERTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
